import React, { Component } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Image,
  Linking,
} from 'react-native';
import PropTypes from 'prop-types';
import Modal from 'react-native-modal';
import LottieView from 'lottie-react-native';
import Utility from '../../../utils/Utility';
import FoxyShadowButton from '../../../lib/FoxyShadowButton';
import colors from '../../../theme/Colors';
import styles from './styles/AlertBoxStyles';
import images from '../../../theme/Images';
import { WHATS_APP_NUMBER } from '../../../config/Constants';

import animations from '../../../theme/Animations';
import FastImageView from '../../FastImageView';
import { isDesktop } from '../../../utils/BooleanUtility';
import { getMinifiedImage } from '../../../utils/ImageUtility';
import { AnalyticsManager } from '../../../analytics';

class FoxyAlert extends Component {
  crossTapped = () => {
    const { cancelPressed } = this.props;
    console.tron.log('cancel alert called in foxy alert');
    cancelPressed();
  };

  componentDidUpdate(prevProps) {
    const { isError, source, isVisible, alertMessage = '' } = this.props;
    if (!prevProps.isVisible && isVisible) {
      if (isError) {
        AnalyticsManager.logEvent('error_captured', {
          source,
          alertMessage: alertMessage.slice(0, 24),
        });
      }
    }
  }

  openWhatsApp = () => {
    Linking.openURL(
      `whatsapp://send?text=Hi, I have a question about sign up.&phone=${WHATS_APP_NUMBER} `,
    );
  };

  hyperLink = (props) => {
    const { whatsappHyperlinkMessage } = this.props;
    console.tron.log('Working => ', whatsappHyperlinkMessage);
    return (
      <TouchableWithoutFeedback
        onPress={() => Utility.openWhatsApp(whatsappHyperlinkMessage)}
      >
        <Text style={styles.hyperLink}>{props.children}</Text>
      </TouchableWithoutFeedback>
    );
  };

  alertMessageContainer = (props) => {
    const {
      showCross = false,
      numOfLines = 3,
      showImage,
      isProfilePicture = false,
      isAssets,
      isAbsolute,
      showJson,
      animation = animations.paymentSuccess,
      animationStyle = styles.alertBoxAnimation,
    } = this.props;
    const messageBoxHeight = props.hideSecondButton
      ? props.alertBoxHeight - 46 * 1
      : props.alertBoxHeight - 46 * 2;
    const numberOfLines = numOfLines || 6;
    const profilePictureStyle = {
      height: 76,
      width: 76,
      borderRadius: 38,
      alignSelf: 'center',
      marginBottom: 10,
      marginTop: 4,
    };
    const regularPictureStyle = {
      width: 60,
      height: 82,
      alignSelf: 'center',
      marginBottom: 4,
      marginTop: 4,
    };

    let pictureStyle = isProfilePicture
      ? profilePictureStyle
      : regularPictureStyle;

    if (isAbsolute) {
      pictureStyle = {
        width: 60,
        height: 60,
        alignSelf: 'center',
        position: 'absolute',
        top: -30,
      };
    }

    const imageSource = isAssets
      ? props.imageUrl
      : {
          uri: getMinifiedImage(
            props.imageUrl,
            pictureStyle.width,
            pictureStyle.height,
          ),
        };

    const alertMessageStyles = styles[`${props.textAlignment}AlertMessage`];

    let alertBoxTitle = styles.alertBoxTitle;

    if (isAbsolute) {
      alertBoxTitle = styles.alertBoxTitleLargeMargin;
    } else if (!showImage && !showJson) {
      alertBoxTitle = styles.alertBoxTitleSmallMargin;
    }
    return (
      <View style={styles.alertMessageContainer}>
        {showImage && (
          <FastImageView
            source={imageSource}
            resizeMode="contain"
            style={pictureStyle}
          />
        )}
        {showJson && (
          <LottieView
            source={animation}
            style={animationStyle}
            autoPlay
            loop={false}
          />
        )}
        <Text style={alertBoxTitle}>{props.alertBoxTitle}</Text>

        {props.showWhatsappHyperlink && (
          <>
            <Text
              numberOfLines={6}
              style={alertMessageStyles}
              allowFontScaling={false}
            >
              {props.alertMessage}
            </Text>
            <Text style={styles.alertMessage}>
              <this.hyperLink>Chat with us on Whatsapp</this.hyperLink> for any
              question
            </Text>
          </>
        )}
        {!props.showWhatsappHyperlink && (
          <Text
            numberOfLines={numberOfLines}
            style={styles.alertMessage}
            allowFontScaling={false}
          >
            {props.alertMessage}
          </Text>
        )}

        <props.ChildrenComponent />
        {showCross ? (
          <TouchableOpacity
            style={styles.crossStyle}
            onPress={this.crossTapped}
          >
            <Image source={images.cross} />
          </TouchableOpacity>
        ) : null}
      </View>
    );
  };

  actionButton = (props) => {
    const {
      hideSecondButton,
      opacity,
      firstActionButtonStyle = {},
      secondActionButtonStyle = {},
    } = props;

    if (hideSecondButton) {
      return null;
    }
    return (
      <TouchableOpacity
        style={[styles.actionButtonsContainer, firstActionButtonStyle]}
        onPress={props.onPress}
      >
        <Text
          style={[styles.actionButtonText, { color: props.textColor, opacity }]}
        >
          {props.title.toUpperCase()}
        </Text>
      </TouchableOpacity>
    );
  };

  actionButtonsContainer = (props) => (
    <View style={styles.actionButtonsContainer}>
      <TouchableOpacity
        style={styles.firstActionButtonContainer}
        onPress={props.firstButtonOnPress}
      >
        <Text
          style={[
            styles.firstActionButtonTitle,
            { color: props.firstButtonTextColor },
          ]}
        >
          {props.firstButtonTitle}
        </Text>
      </TouchableOpacity>
      <FoxyShadowButton
        width={165}
        title={props.secondButtonTitle}
        onPress={props.secondButtonOnPress}
        backgroundColor={props.secondButtonBackgroundColor}
      />
    </View>
  );

  onPressOutside = () => {
    const { secondButtonOnPress, onTapOutside } = this.props;
    if (onTapOutside) {
      onTapOutside();
    } else {
      secondButtonOnPress();
    }
  };

  render() {
    const {
      height,
      alertBoxTitle,
      alertMessage,
      firstButtonTitle,
      firstButtonTextColor,
      secondButtonTitle,
      secondButtonTextColor,
      firstButtonOnPress,
      secondButtonOnPress,
      isVisible,
      Children,
      onTapOutside,
      textAlignment,
      hideSecondButton = false,
      showWhatsappHyperlink,
      autoWrapContent,
      image_url,
      firstActionButtonStyle,
      secondActionButtonStyle,
      isAssets,
    } = this.props;
    const ChildrenComponent = Children;
    const boxHeight = !autoWrapContent ? { height } : {};
    return (
      <Modal
        isVisible={isVisible}
        onBackdropPress={this.onPressOutside}
        style={{
          margin: 0,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
        onSwipeEnd={this.onPressOutside}
        onSwipeComplete={this.onPressOutside}
        swipeDirection="down"
        swipeThreshold={200}
        propagateSwipe
        backdropTransitionOutTiming={0}
      >
        <View
          style={[
            styles.alertBoxContainer,
            {
              top: (Utility.getScreenHeight() - height - 120) / 2,
              alignSelf: 'center',
            },
            boxHeight,
            isDesktop() && styles.desktopModal,
          ]}
        >
          <this.alertMessageContainer
            alertMessage={alertMessage}
            alertBoxTitle={alertBoxTitle}
            alertBoxHeight={height}
            ChildrenComponent={ChildrenComponent}
            hideSecondButton={hideSecondButton}
            textAlignment={textAlignment}
            showWhatsappHyperlink={showWhatsappHyperlink}
            imageUrl={image_url}
          />
          <this.actionButton
            textColor={firstButtonTextColor}
            onPress={firstButtonOnPress}
            title={firstButtonTitle}
            hideSecondButton={false}
            firstActionButtonStyle={firstActionButtonStyle}
            opacity={1}
          />
          <this.actionButton
            textColor={secondButtonTextColor}
            onPress={secondButtonOnPress}
            title={secondButtonTitle}
            hideSecondButton={hideSecondButton}
            secondActionButtonStyle={secondActionButtonStyle}
            opacity={0.7}
          />
        </View>
      </Modal>
    );
  }
}

FoxyAlert.propTypes = {
  isVisible: PropTypes.bool,
  height: PropTypes.number,
  alertBoxTitle: PropTypes.string,
  alertMessage: PropTypes.string,
  firstButtonTitle: PropTypes.string,
  firstButtonTextColor: PropTypes.string,
  secondButtonTitle: PropTypes.string,
  secondButtonTextColor: PropTypes.string,
  firstButtonOnPress: PropTypes.func,
  secondButtonOnPress: PropTypes.func,
  Children: PropTypes.func,
  onTapOutside: PropTypes.func,
  showSecondButton: PropTypes.bool,
  textAlignment: PropTypes.string,
  showWhatsappHyperlink: PropTypes.bool,
  whatsappHyperlinkMessage: PropTypes.string,
};

FoxyAlert.defaultProps = {
  isVisible: false,
  height: 206,
  alertBoxTitle: '',
  alertMessage: '',
  firstButtonTitle: '',
  firstButtonTextColor: colors.enabled,
  secondButtonTextColor: colors.foxyBlack,
  secondButtonTitle: 'Discard',
  secondButtonBackgroundColor: colors.enabled,
  firstButtonOnPress: () => {},
  secondButtonOnPress: () => {},
  Children: () => <View />,
  onTapOutside: () => {},
  showSecondButton: true,
  textAlignment: 'justify',
  showWhatsappHyperlink: false,
  whatsappHyperlinkMessage: '',
};

export default FoxyAlert;
